import { render, staticRenderFns } from "./BackerCenterPendingActionsSlider.vue?vue&type=template&id=5825bbcf"
import script from "./BackerCenterPendingActionsSlider.vue?vue&type=script&lang=js"
export * from "./BackerCenterPendingActionsSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports